/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ITasksQueryVariables = Types.Exact<{
  status?: Types.InputMaybe<Types.TaskStatusEnum>;
  eventTypes?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  criticality?: Types.InputMaybe<Types.TaskCriticalityEnum>;
  createdAfter?: Types.InputMaybe<Types.Scalars['ISO8601Date']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  appId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type ITasksQuery = {
  __typename?: 'Query';
  tasks: {
    __typename?: 'TaskPage';
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    nodesCount: number;
    pagesCount: number;
    nodes: Array<{
      __typename?: 'Task';
      id: string;
      createdAt: any;
      criticality: Types.TaskCriticalityEnum;
      eventType: string;
      payload: any;
      parentId: string;
      parentType: string;
      recordId: string;
    }>;
  };
};

export const TasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'tasks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TaskStatusEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventTypes' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criticality' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TaskCriticalityEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createdAfter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'appId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventTypes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventTypes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'criticality' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'criticality' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createdAfter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createdAfter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'appId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'appId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payload' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'recordId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pagesCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ITasksQuery, ITasksQueryVariables>;
